import React, { useEffect, useState } from "react";
import { api, fmtDateTime } from "@/lib/apiClient";

export default function Activity() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/activity?limit=200");
                setItems(data);
            } catch (e) {
                /* best-effort */
            }
        })();
    }, []);

    return (
        <div className="space-y-6">
            <header>
                <div className="overline mb-1">// Audit</div>
                <h1 className="font-display text-4xl tracking-tighter">Activity Log</h1>
                <p className="text-slate-500 mt-2 text-sm">Every action across the workspace.</p>
            </header>

            <div className="bg-white border border-slate-200">
                <ol className="divide-y divide-slate-100">
                    {items.map((a) => (
                        <li key={a.id} className="flex items-start gap-4 px-5 py-4" data-testid={`activity-${a.id}`}>
                            <span className="w-1.5 h-1.5 bg-slate-900 mt-2 shrink-0" />
                            <div className="flex-1 min-w-0">
                                <div className="text-sm">
                                    <span className="font-medium">{a.actor_name}</span>
                                    <span className="text-slate-500"> performed </span>
                                    <span className="font-mono text-xs bg-slate-100 px-1.5 py-0.5">{a.action}</span>
                                    <span className="text-slate-500"> on </span>
                                    <span className="font-mono text-xs">{a.entity_type}</span>
                                </div>
                                <div className="overline text-slate-400 mt-0.5">{fmtDateTime(a.created_at)}</div>
                            </div>
                        </li>
                    ))}
                    {items.length === 0 && <li className="px-5 py-10 text-center text-sm text-slate-500">No activity yet.</li>}
                </ol>
            </div>
        </div>
    );
}
